import React from 'react';
import styled, { css } from 'styled-components';

import { Container } from '@nfs-react/components';

import { useImg, useText } from 'hooks';
import { MOBILE, TABLET } from 'helpers/styles/media';
import { ChangeableBackgroundSection } from 'helpers/components';

const Article1 = () => {
  const user = [
    {
      name: useText('name_title', true),
      price: useText('price_title', true),
      country: [
        {
          flag: '',
          countryName: useText('country_title', true),
        },
      ],
    },
    {
      name: useText('name_1', true),
      price: useText('price_1', true),
      country: [
        {
          flag: useImg('flag_Denmark.svg', 'flag_Denmark'),
          countryName: useText('country_1', true),
        },
      ],
    },
    {
      name: useText('name_2', true),
      price: useText('price_2', true),
      country: [
        {
          flag: useImg('flag_Denmark.svg', 'flag_Denmark'),
          countryName: useText('country_2', true),
        },
      ],
    },
    {
      name: useText('name_3', true),
      price: useText('price_3', true),
      country: [
        {
          flag: useImg('flag_Germany.svg', 'flag_Germany'),
          countryName: useText('country_3', true),
        },
      ],
    },
    {
      name: useText('name_4', true),
      price: useText('price_4', true),
      country: [
        {
          flag: useImg('flag_Denmark.svg', 'flag_Denmark'),
          countryName: useText('country_4', true),
        },
      ],
    },
    {
      name: useText('name_5', true),
      price: useText('price_5', true),
      country: [
        {
          flag: useImg('flag_Switzerland.svg', 'flag_Switzerland'),
          countryName: useText('country_5', true),
        },
      ],
    },
    {
      name: useText('name_6', true),
      price: useText('price_6', true),
      country: [
        {
          flag: useImg('flag_Ireland.svg', 'flag_Ireland'),
          countryName: useText('country_6', true),
        },
      ],
    },
    {
      name: useText('name_7', true),
      price: useText('price_7', true),
      country: [
        {
          flag: useImg('flag_Belgium.svg', 'flag_Belgium'),
          countryName: useText('country_7', true),
        },
      ],
    },
    {
      name: useText('name_8', true),
      price: useText('price_8', true),
      country: [
        {
          flag: useImg('flag_Finland.svg', 'flag_Finland'),
          countryName: useText('country_8', true),
        },
      ],
    },
    {
      name: useText('name_9', true),
      price: useText('price_9', true),
      country: [
        {
          flag: useImg('flag_Denmark.svg', 'flag_Denmark'),
          countryName: useText('country_9', true),
        },
      ],
    },
    {
      name: useText('name_10', true),
      price: useText('price_10', true),
      country: [
        {
          flag: useImg('flag_Finland.svg', 'flag_Finland'),
          countryName: useText('country_10', true),
        },
      ],
    },
  ];
  return (
    <ChangeableBackgroundSection
      id="article1-wrapper-bg"
      defaultStyle={{ background: '#fff' }}
      wrapperCss={wraperStyles}
    >
      <ArticleContainer>
        <Wrapper>
          <ArticleSubtitle>{useText('article1__subtitle', true)}</ArticleSubtitle>
          <Block>
            <Item>{useText('article1__text1', true)}</Item>
            <Item>{useText('article1__text2', true)}</Item>
            <Item>{useText('article1__text3', true)}</Item>
          </Block>
          <ArticleSubtitle>{useText('article1__subtitle_1', true)}</ArticleSubtitle>
          <Image>
            {useImg('article_img_1.webp', 'article_img_1')}
            {useText('article__img_text_1', true)}
          </Image>
          <Button>{useText('article1__btn', true)}</Button>
          <ArticleSubtitle>{useText('article1__subtitle_2', true)}</ArticleSubtitle>
          <Item>{useText('article1__text4', true)}</Item>
          <BlockTable>
            {user.map(({ name, price, country }, index) => {
              const id = index + 1;
              return (
                <Line key={id}>
                  <Name>{name}</Name>
                  <Price>{price}</Price>
                  {country.map(({ flag, countryName }, i) => {
                    return (
                      <Country key={i}>
                        {flag}
                        {countryName}
                      </Country>
                    );
                  })}
                </Line>
              );
            })}
          </BlockTable>
        </Wrapper>
      </ArticleContainer>
    </ChangeableBackgroundSection>
  );
};

const wraperStyles = css`
  padding: 0 0 30px;
`;

const ArticleContainer = styled(Container)`
  display: flex;
  flex-direction: column;

  @media ${TABLET} {
    max-width: 1200px;
  }

  @media ${MOBILE} {
    flex-direction: column;
    max-width: 768px;
    padding: 0;
  }
`;

const Wrapper = styled.div`
  max-width: 800px;

  @media ${TABLET} {
    padding-right: 10px;
    padding-left: 20px;
    max-width: 700px;
  }

  @media ${MOBILE} {
    padding: 0 20px;
  }
`;

const Item = styled.div`
  letter-spacing: 0.5px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #1d1d1d;

  * {
    display: inline;
  }

  span {
    color: #e60505;
    font-weight: bold;
    display: inline;
    cursor: pointer;
  }
`;

const Block = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ArticleSubtitle = styled.div`
  h2 {
    margin: 0;
    color: #141414;
    font-size: 24px;
    font-weight: 700;
    line-height: 28px;
    margin-block: 24px;
  }
`;

const Image = styled.div`
  position: relative;
  margin-top: 24px;
  cursor: pointer;

  p {
    background: #e5e5e5;
    width: auto;
    display: block;
    margin-bottom: 1em;
    padding: 10px;
    font-size: 14px;
    color: #555;
    position: relative;
    top: -4px;
  }
`;

const Button = styled.div`
  display: block;
  background-color: red;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  text-decoration: none;
  color: #fff;
  padding: 12px 24px;
  margin: 0 auto;
  border-radius: 8px;
  border: none;
  width: 70%;
  border-bottom: 1px dashed;
  cursor: pointer;

  a {
    text-decoration: none;
    color: #fff;
  }

  &:hover {
    transform: scale(1.1);
  }
`;

const BlockTable = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;

  > div:first-child {
    font-weight: 700;
  }
`;

const Line = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
`;

const Name = styled.div`
  position: relative;
  width: 35%;
  margin-left: 20px;

  ::before {
    content: "";
    position: absolute;
    left: -10px;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: green;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
  }
`;

const Price = styled.div`
  width: 30%;
  font-weight: 700;
`;

const Country = styled.div`
  width: 35%;
  display: flex;
  align-items: center;
  gap: 4px;
  align-items: flex-start;

  img {
    width: 16px;
    height: 16px;
  }
`;

export default Article1;
